<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline"
    :class="[width, height]"
    viewBox="0 0 70.492 79.365"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="1.143"
        y1="0.696"
        x2="0.085"
        y2="0.953"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#de4551" stop-opacity="0" />
        <stop offset="1" stop-color="#de4551" />
      </linearGradient>
    </defs>
    <g id="Group_240" data-name="Group 240" transform="translate(-28.622 0)">
      <path
        id="Path_860"
        data-name="Path 860"
        d="M170.672.066c-14.853,1.341-16.29,29.828-22.7,44.424-3.174,7.232-10.66,14.694-9.341,23.218,1.489,9.616,11.3,12.412,18.862,11.492,18.713-2.276,26.8-21.865,28.025-40.427.755-11.444,3.147-40.332-14.851-38.707Z"
        transform="translate(-92.829 0)"
        fill="url(#linear-gradient)"
      />
      <g id="Group_239" data-name="Group 239" transform="translate(28.622 1.833)">
        <g id="Group_237" data-name="Group 237" transform="translate(0)">
          <g id="Group_229" data-name="Group 229" transform="translate(0 4.65)" opacity="0.1">
            <path
              id="Path_861"
              data-name="Path 861"
              d="M299.058,68.228h4.665a14.1,14.1,0,1,0-5.44-5.441v4.665a.775.775,0,0,0,.775.775Z"
              transform="translate(-254.972 -41.821)"
              fill="#2f3042"
            />
            <path
              id="Path_862"
              data-name="Path 862"
              d="M94.629,92.828,87,88.274a3.591,3.591,0,0,0-4.428.594l-2.8,2.916s-4.9-1.765-11.831-8.694-8.694-11.831-8.694-11.831l2.916-2.8a3.59,3.59,0,0,0,.594-4.428L58.2,56.4a3.59,3.59,0,0,0-4.707-1.362l-2.352,1.193a10.712,10.712,0,0,0-4.481,14.8A86.8,86.8,0,0,0,80,104.368a10.754,10.754,0,0,0,3.156,1.168l4.979,4.979a1.55,1.55,0,0,0,2.192,0l.079-.079a.775.775,0,0,0,.1.131l1.918,1.918a6.121,6.121,0,0,1-8.657,8.656l-6.8-6.8a2.957,2.957,0,0,0-4.182,0l-.621.621a1.472,1.472,0,0,1-2.082-2.082l2.451-2.451a3.022,3.022,0,0,0-4.274-4.274l-2.451,2.451a1.472,1.472,0,0,1-2.082-2.082l2.451-2.451A3.022,3.022,0,0,0,61.912,99.8l-2.451,2.451a1.472,1.472,0,0,1-2.082-2.082l2.451-2.451a3.022,3.022,0,0,0-4.274-4.274L53.1,95.9a1.472,1.472,0,0,1-2.082-2.082l2.451-2.451A3.022,3.022,0,0,0,49.2,87.092l-2.451,2.451a1.472,1.472,0,0,1-2.082-2.082l.621-.621a2.956,2.956,0,0,0,0-4.182L40.8,78.172A7.136,7.136,0,1,0,30.709,88.264l34.2,34.2a.775.775,0,0,0,1.1-1.1l-34.2-34.2a5.586,5.586,0,1,1,7.9-7.9l4.486,4.487a1.407,1.407,0,0,1,0,1.989l-.621.621a3.022,3.022,0,0,0,4.274,4.274L50.3,88.188a1.472,1.472,0,1,1,2.082,2.082l-2.451,2.451A3.022,3.022,0,1,0,54.2,96.995l2.451-2.451a1.472,1.472,0,0,1,2.082,2.082l-2.451,2.451a3.022,3.022,0,1,0,4.274,4.274l2.451-2.451a1.472,1.472,0,0,1,2.082,2.082l-2.451,2.451a3.022,3.022,0,0,0,4.274,4.274l2.451-2.451a1.472,1.472,0,1,1,2.082,2.082l-2.451,2.451a3.022,3.022,0,1,0,4.274,4.274l.621-.621a1.407,1.407,0,0,1,1.99,0l6.8,6.8a7.671,7.671,0,1,0,10.849-10.849L91.6,109.47a.773.773,0,0,0-.131-.1l.079-.079a1.55,1.55,0,0,0,0-2.192l-2.177-2.177a10.634,10.634,0,0,0,5.421-5.03l1.193-2.352a3.59,3.59,0,0,0-1.361-4.707Z"
              transform="translate(-28.622 -52.659)"
              fill="#2f3042"
            />
          </g>
          <g id="Group_236" data-name="Group 236" transform="translate(0)">
            <g id="Group_232" data-name="Group 232" transform="translate(40.748)">
              <g id="Group_231" data-name="Group 231">
                <g id="Group_230" data-name="Group 230">
                  <path
                    id="Path_863"
                    data-name="Path 863"
                    d="M324.675,31.561a14.1,14.1,0,1,0-26.392,6.227v4.665a.775.775,0,0,0,.775.775h4.665a14.1,14.1,0,0,0,20.952-11.668Z"
                    transform="translate(-295.72 -16.047)"
                    fill="#fff"
                  />
                  <path
                    id="Path_864"
                    data-name="Path 864"
                    d="M304.565,41.452a.773.773,0,0,1-.1-.006,14.74,14.74,0,0,1-5.165-1.664h-4.466a1.552,1.552,0,0,1-1.55-1.55V33.765a14.855,14.855,0,1,1,15.965,7.52.775.775,0,1,1-.3-1.521A13.368,13.368,0,0,0,319.677,27.3a13.323,13.323,0,0,0-13.916-13.916,13.321,13.321,0,0,0-11.026,19.8.775.775,0,0,1,.1.378v4.665H299.5a.775.775,0,0,1,.378.1,13.2,13.2,0,0,0,4.785,1.578.775.775,0,0,1-.1,1.544Z"
                    transform="translate(-291.496 -11.825)"
                    fill="#2f3042"
                  />
                </g>
              </g>
            </g>
            <g id="Group_235" data-name="Group 235" transform="translate(0 1.991)">
              <path
                id="Path_865"
                data-name="Path 865"
                d="M379.969,338.851l-5.975-5.975,3.42-3.42,5.975,5.975a1.55,1.55,0,0,1,0,2.192l-1.228,1.228A1.55,1.55,0,0,1,379.969,338.851Z"
                transform="translate(-320.458 -282.211)"
                fill="#fff"
              />
              <g id="Group_234" data-name="Group 234" transform="translate(16.66 0.772)">
                <path
                  id="Path_866"
                  data-name="Path 866"
                  d="M158.757,58.09c6.929,6.929,11.831,8.694,11.831,8.694l2.8-2.916a3.591,3.591,0,0,1,4.428-.594l7.628,4.554a3.591,3.591,0,0,1,1.362,4.707l-1.193,2.352a10.712,10.712,0,0,1-14.8,4.481,86.532,86.532,0,0,1-18.977-14.362A86.536,86.536,0,0,1,137.478,46.03a10.712,10.712,0,0,1,4.481-14.8l2.352-1.193a3.591,3.591,0,0,1,4.707,1.362l4.554,7.628a3.591,3.591,0,0,1-.594,4.428l-2.916,2.8s1.765,4.9,8.694,11.831Z"
                  transform="translate(-136.103 -29.648)"
                  fill="#02ffb3"
                />
                <path
                  id="Path_867"
                  data-name="Path 867"
                  d="M158.757,58.09c6.929,6.929,11.831,8.694,11.831,8.694l2.8-2.916a3.591,3.591,0,0,1,4.428-.594l7.628,4.554a3.591,3.591,0,0,1,1.362,4.707l-1.193,2.352a10.712,10.712,0,0,1-14.8,4.481,86.532,86.532,0,0,1-18.977-14.362A86.536,86.536,0,0,1,137.478,46.03a10.712,10.712,0,0,1,4.481-14.8l2.352-1.193a3.591,3.591,0,0,1,4.707,1.362l4.554,7.628a3.591,3.591,0,0,1-.594,4.428l-2.916,2.8s1.765,4.9,8.694,11.831Z"
                  transform="translate(-136.103 -29.648)"
                  fill="#fff"
                />
                <g id="Group_233" data-name="Group 233" transform="translate(6.806 0)">
                  <path
                    id="Path_868"
                    data-name="Path 868"
                    d="M209.7,200.741l-2.76,2.76a87,87,0,0,1-15.148-15.148l2.76-2.76a1.551,1.551,0,0,1,2.192,0L209.7,198.549a1.551,1.551,0,0,1,0,2.192Z"
                    transform="translate(-189.963 -161.037)"
                    fill="#f0324c"
                  />
                  <path
                    id="Path_869"
                    data-name="Path 869"
                    d="M190.079,43.455l-1.566,1.507a98.571,98.571,0,0,1-7.549-11.918,12.566,12.566,0,0,1-.955-2.3l1.4-.711a3.59,3.59,0,0,1,4.707,1.361l4.555,7.629a3.59,3.59,0,0,1-.594,4.428Z"
                    transform="translate(-180.009 -29.648)"
                    fill="#f0324c"
                  />
                  <path
                    id="Path_870"
                    data-name="Path 870"
                    d="M381.154,254.476a12.564,12.564,0,0,1-2.3-.955,98.6,98.6,0,0,1-11.918-7.549l1.507-1.566a3.59,3.59,0,0,1,4.428-.594l7.629,4.555a3.59,3.59,0,0,1,1.361,4.707Z"
                    transform="translate(-337.964 -210.186)"
                    fill="#f0324c"
                  />
                </g>
              </g>
              <path
                id="Path_871"
                data-name="Path 871"
                d="M95.489,71.032l1.193-2.352a4.378,4.378,0,0,0-1.656-5.723L87.4,58.4a4.346,4.346,0,0,0-5.384.722l-2.435,2.532C78.232,61.045,74,58.85,68.485,53.336s-7.71-9.748-8.321-11.094L62.7,39.807a4.346,4.346,0,0,0,.722-5.384l-4.554-7.628a4.378,4.378,0,0,0-5.723-1.656l-2.352,1.193A11.487,11.487,0,0,0,45.983,42.2a87.67,87.67,0,0,0,12.9,17.5A.775.775,0,0,0,60,58.639,86.11,86.11,0,0,1,47.335,41.444a9.937,9.937,0,0,1,4.155-13.73l2.352-1.193a2.824,2.824,0,0,1,3.691,1.068l4.554,7.628a2.8,2.8,0,0,1-.466,3.472l-2.916,2.8a.775.775,0,0,0-.192.821c.074.207,1.9,5.145,8.876,12.116s11.91,8.8,12.116,8.875a.775.775,0,0,0,.821-.192l2.8-2.916a2.8,2.8,0,0,1,3.472-.466l7.628,4.554A2.824,2.824,0,0,1,95.3,67.979l-1.193,2.352a9.937,9.937,0,0,1-13.73,4.155,86.1,86.1,0,0,1-17.2-12.669.775.775,0,1,0-1.067,1.124,87.665,87.665,0,0,0,17.507,12.9,11.6,11.6,0,0,0,3.156,1.209l4.81,4.81a2.325,2.325,0,0,0,3.288,0l.066-.066,1.487,1.487a6.121,6.121,0,1,1-8.657,8.656l-6.8-6.8a2.957,2.957,0,0,0-4.182,0l-.621.621a1.472,1.472,0,0,1-2.082-2.082l2.451-2.451a3.022,3.022,0,0,0-4.274-4.274L65.818,79.4a1.472,1.472,0,0,1-2.082-2.082l2.451-2.451A3.022,3.022,0,0,0,61.913,70.6l-2.451,2.451a1.472,1.472,0,0,1-2.082-2.082l2.451-2.451a3.022,3.022,0,1,0-4.274-4.274l-2.451,2.451a1.472,1.472,0,0,1-2.082-2.082l2.451-2.451A3.022,3.022,0,0,0,49.2,57.886L46.75,60.337a1.472,1.472,0,0,1-2.082-2.082l.621-.621a2.956,2.956,0,0,0,0-4.182L40.8,48.966A7.136,7.136,0,0,0,30.71,59.058l34.2,34.2a.775.775,0,0,0,1.1-1.1l-34.2-34.2a5.586,5.586,0,1,1,7.9-7.9l4.486,4.487a1.407,1.407,0,0,1,0,1.989l-.621.621a3.022,3.022,0,0,0,4.274,4.274L50.3,58.982a1.472,1.472,0,1,1,2.082,2.082l-2.451,2.451A3.022,3.022,0,1,0,54.2,67.789l2.451-2.451a1.472,1.472,0,0,1,2.082,2.082l-2.451,2.451a3.022,3.022,0,0,0,4.274,4.274l2.451-2.451a1.472,1.472,0,0,1,2.082,2.082l-2.451,2.451A3.022,3.022,0,0,0,66.913,80.5l2.451-2.451a1.472,1.472,0,0,1,2.082,2.082L69,82.583a3.022,3.022,0,0,0,4.274,4.274l.621-.621a1.407,1.407,0,0,1,1.99,0l6.8,6.8A7.671,7.671,0,1,0,93.523,82.182L92.036,80.7l.066-.066a2.325,2.325,0,0,0,0-3.288l-1.4-1.4a11.355,11.355,0,0,0,4.787-4.91Zm-4.483,7.405a.775.775,0,0,1,0,1.1l-1.228,1.228a.775.775,0,0,1-1.1,0l-3.443-3.443a11.561,11.561,0,0,0,3.364-.505q.3-.09.584-.195Z"
                transform="translate(-28.623 -24.669)"
                fill="#2f3042"
              />
            </g>
          </g>
        </g>
        <g id="Group_238" data-name="Group 238" transform="translate(8.025 7.883)">
          <path
            id="Path_872"
            data-name="Path 872"
            d="M88.049,106.815a2.247,2.247,0,1,1,1.589-.657A2.241,2.241,0,0,1,88.049,106.815Zm0-2.944a.7.7,0,1,0,.493.2A.7.7,0,0,0,88.049,103.871Z"
            transform="translate(-84.964 -96.177)"
            fill="#f0324c"
          />
          <path
            id="Path_873"
            data-name="Path 873"
            d="M107.049,376.705a2.247,2.247,0,1,1,1.589-.657A2.241,2.241,0,0,1,107.049,376.705Zm0-2.944a.7.7,0,1,0,.493.2A.7.7,0,0,0,107.049,373.762Z"
            transform="translate(-101.019 -324.232)"
            fill="#f0324c"
          />
          <path
            id="Path_874"
            data-name="Path 874"
            d="M84.111,65.7a.772.772,0,0,1-.548-.227l-.925-.924-.925.924a.775.775,0,0,1-1.1-1.1l1.473-1.473a.775.775,0,0,1,1.1,0l1.473,1.473a.775.775,0,0,1-.548,1.323Z"
            transform="translate(-80.391 -62.68)"
            fill="#f0324c"
          />
          <path
            id="Path_875"
            data-name="Path 875"
            d="M440.075,229.34a.772.772,0,0,1-.548-.227l-.925-.924-.925.924a.775.775,0,0,1-1.1-1.1l1.473-1.473a.775.775,0,0,1,1.1,0l1.473,1.473a.775.775,0,0,1-.548,1.323Z"
            transform="translate(-381.177 -200.952)"
            fill="#f0324c"
          />
          <path
            id="Path_876"
            data-name="Path 876"
            d="M308.964,464.72a.772.772,0,0,1-.548-.227l-.925-.924-.925.924a.775.775,0,0,1-1.1-1.1l1.473-1.473a.775.775,0,0,1,1.1,0l1.473,1.473a.775.775,0,0,1-.548,1.323Z"
            transform="translate(-270.39 -399.845)"
            fill="#f0324c"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-14'
    },
    height: {
      type: String,
      default: 'h-16'
    }
  }
}
</script>
